import $ from 'jquery';

export default function productReviewsModule() {
  const productReviewsElement = $('#pr-reviewdisplay');
  if (productReviewsElement.length) {
    return import(/* webpackChunkName: "productReviews" */ '../productReviews')
      .then(({ default: ProductReviews }) => {
        const productReviews = new ProductReviews();
        return productReviews;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
